import { OWNERSHIP_DURATION } from 'Const/farm/ownership_duration.json';

export default function (value) {
  const val = OWNERSHIP_DURATION[value];
  if (!val) return '';
  return val;
}
